import { PartnerProductConfigurationContext } from '../providers/PartnerProductConfigurationProvider';
import { useContext } from 'react';

export const usePartnerProductConfiguration = () =>
    useContext(PartnerProductConfigurationContext);
